var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.1872C18.843 18.001 17.2107 18.001 13.9462 18.001H9.96412C6.6996 18.001 5.06734 18.001 3.9103 17.1872C3.48223 16.8861 3.1099 16.5121 2.81017 16.0821C2 14.9198 2 13.2802 2 10.001C2 6.72175 2 5.08214 2.81017 3.91989C3.1099 3.48989 3.48223 3.11588 3.9103 2.8148C5.06734 2.00098 6.6996 2.00098 9.96412 2.00098",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18V22",
    stroke: "#808191",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.999H16",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.00098C19.8856 2.00098 20.8284 2.00098 21.4142 2.58677C22 3.17255 22 4.11536 22 6.00098V10.001C22 11.8866 22 12.8294 21.4142 13.4152C20.8284 14.001 19.8856 14.001 18 14.001H17C15.1144 14.001 14.1716 14.001 13.5858 13.4152C13 12.8294 13 11.8866 13 10.001V6.00098C13 4.11536 13 3.17255 13.5858 2.58677C14.1716 2.00098 15.1144 2.00098 17 2.00098H18Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.499H17.509",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.060a21fdd004e47ce111a04ebf286620.svg";
export { ForwardRef as ReactComponent };